<template lang="pug">
  v-tabs(fixed-tabs v-model='tab')
    v-tab Flows
    v-tab Questions
    v-tab Selects
    v-tab-item
      FlowsFrame(:tab='tab')
    v-tab-item
      Questions
    v-tab-item
      Selects
</template>

<script>
import FlowsFrame from '@/components/Admin/Flows/FlowsFrame/index'
import Questions from '@/components/Admin/Flows/Questions/index'
import Selects from '@/components/Admin/Flows/Selects/index'

export default {
  components: { FlowsFrame, Questions, Selects },
  data () {
    return {
      tab: 0
    }
  }
}
</script>